export const canDuplicate = (
    hasEssential: boolean,
    userIsSupport: boolean,
): boolean => !hasEssential || userIsSupport;
export const canShowEdit = (
    canEdit: boolean,
    isExploreUser: boolean,
    hasEssential: boolean,
    userIsAdmin: boolean,
): boolean => canEdit && (isExploreUser || (hasEssential && userIsAdmin));
export const canRename = (canEdit: boolean): boolean => canEdit;
export const canDelete = (
    canEdit: boolean,
    hasEssential: boolean,
    userIsAdmin: boolean,
    userIsSupport: boolean,
): boolean => canEdit && (!hasEssential || userIsAdmin || userIsSupport);
export const canInsert = (canEdit: boolean, isExploreUser: boolean): boolean =>
    canEdit && isExploreUser;

export const displayFirstSeparator = (
    displayAlert: boolean,
    displayDelete: boolean,
    displayDuplicate: boolean,
    displayEdit: boolean,
    displayRename: boolean,
    displayResize: boolean,
): boolean =>
    displayDuplicate &&
    (displayEdit ||
        displayRename ||
        displayResize ||
        displayDelete ||
        displayAlert);

export const displayLastSeparator = (
    displayAlert: boolean,
    displayDelete: boolean,
    displayInsert: boolean,
    displayEdit: boolean,
    displayRename: boolean,
    displayResize: boolean,
): boolean =>
    displayInsert &&
    (displayEdit ||
        displayRename ||
        displayResize ||
        displayDelete ||
        displayAlert);

export const shouldNotDisplayChartEditMenu = (
    displayAlert: boolean,
    displayDelete: boolean,
    displayDuplicate: boolean,
    displayEdit: boolean,
    displayInsert: boolean,
    displayRename: boolean,
    displayResize: boolean,
): boolean => {
    return (
        !displayDuplicate &&
        !displayEdit &&
        !displayRename &&
        !displayResize &&
        !displayDelete &&
        !displayAlert &&
        !displayInsert
    );
};
